<template>
  <div>
    <div class="new_page_tabpc" style="padding-left: 13%; flex: 1;">
      <router-link to="/sport/lsport/prematch" ><span>엘스포츠 유럽형</span></router-link>
      <router-link to="/sport/prematch"><span>벳컨 유럽형</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-프리매치' }" class="cho"><span>오즈메트릭스</span></router-link>
    </div>
    <div style="display: flex;">
      <SideBar/>
      <div style="flex: 1;">
        <div class="sports-table-container">
          <SportsTable 
            :select-game="selectGame"
            :selected-hour="params.hour"
            :select-hour="selectHour"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SportsTable from '@/components/OddsMatrix/SportsTable.vue'
import SideBar from '@/components/OddsMatrix/SideBar.vue'

import MSG from '../../../contants/msg'

import {mapState, mapActions } from "vuex";

export default {
  name: "Sports",
  components: {
    SideBar,
    SportsTable,
  },
  data: function () {
    return {
      params: {
        hour: 6
      },
      selectedGame: null,  
    }
  },
  computed: {
    //보너스
    bonus: function () {
      return this.$store.state.setting.settings ? this.$store.state.setting.settings.config.option.bettingOption.sportsFolder.filter(e => e.active === true) : []
    },
    // 마감시간
    endTime: function () {
      return this.$store.state.setting.settings.config.option.gameEndtime.find(e => e.gameName === '스포츠').endTime
    },
    menuVisible(){
      return this.$store.getters['MENU_VISIBLE'];
    },
    europeanVisible(){
      return this.menuVisible?.find(e => e.name === '스포츠-유럽형').visible
    },
    ...mapState({
      dateCnt: state => state.lsport.dateCnt,
      user: state => state.user.user,
      cartItem: state => state.lsport.cart,
    }),
  },
  mounted: function () {
    if (!this.europeanVisible){
      this.$store.dispatch('SHOW_ERR_MSG3', '유럽형은 점검중 입니다.')
    }
    // 웹소켓 연결
    this.connectSocket();
    this.tryFetchEvents();
  },
  beforeDestroy () {
    this.disconnectSocket();
  },
  methods: {
    ...mapActions('oddsmatrix', ['fetchEvents', 'connectSocket', 'disconnectSocket']),
    tryFetchEvents() {
      if (this.$store.state.oddsmatrix.socket && this.$store.state.oddsmatrix.socket.readyState === 1) {
        this.fetchEvents(this.params);
      } else {
        // 소켓이 아직 안 열렸으면, onopen에서 요청
        this.$store.state.oddsmatrix.socket.onopen = () => {
          this.fetchEvents(this.params);
        };
      }
    },
    /*
    * 종목의 자세히 버튼
    * **/
    checkArray: function (id) {
      let result = this.openDetailGame.indexOf(id) >= 0
      return result
    },

    /**
     * 토글 액션
     * */
    selectHour(hour) {
      this.params.hour = hour;
      this.fetchEvents(this.params);
    },
    addCart: function (bets, folders, game) {
      if (this.user){
        const config = this.user.members_detail_setting;
        if (!config.베팅권한.유럽형.active) {
          return alert(MSG.authorization);
        }
      } else {
        return alert(MSG.isNotLogin);
      }

      const cartItem = {
        gameId: game.id,
        gameSeq: game.seq,
        betsSeq: bets.seq,
        betsStatus: bets.status,
        betsId: bets.id,
        betsName: bets.name,
        betsUpdated: false,
        betsPrevOdds: bets.price,
        sportsId: game.sportSeq,
        foldersSeq: folders.seq,
        foldersType: folders.type,
        foldersStatus: folders.status,
        odds: bets.price,
        line: bets.line ? bets.line : null,
        leagueId: game.leagueId,
        leagueNameKr: game.league.nameKr,
        leagueNameEn: game.league.nameEn,
        leagueNameIcon: game.league.icon,
        sportNameKr: game.sport.nameKr,
        sportNameEn: game.sport.nameEn,
        sportNameIcon: game.sport.icon,
        homeNameKr: game.homeTeam.nameKr,
        homeNameEn: game.homeTeam.nameEn,
        awayNameKr: game.awayTeam.nameKr,
        awayNameEn: game.awayTeam.nameEn,
        marketNameKr: folders.market.nameKr,
        marketNameEn: folders.market.nameEn,
        marketsId: folders.marketId,
        startTime: game.startTime,
        odds1: folders.line,
        odds2: null,
        odds3: null,
        betType: '프리매치(엘스포츠-유럽형)',
        detailType: null,
        currentPeriod: game.currentPeriod,
        currentTime: game.currentTime,
        homeScore: game.homeResult,
        awayScore: game.awayResult,
        penalty: null,
        maxAmount: game.league?.maxAmount
      };
      console.log('카트아이템', cartItem)
      cartItem.marketNameKr = folders.market.nameKr?.replace('{sw}', game.sport.periodName);
      cartItem.marketNameEn = folders.market.nameEn?.replace('{sw}', game.sport.periodName);

      if (game.sport.periodName === '반전') {
        cartItem.marketNameKr = folders.market.nameKr?.replace('1{sw}', '전반전')
        cartItem.marketNameEn = folders.market.nameEn?.replace('2{sw}', '후반전')
      }
      this.$store.dispatch('ADD_LSPORT_EUROPEAN_CART_ITEM', cartItem)
    },
    selectGame(game){
      this.$router.push({ name: '오즈매트릭스-자세히', query: { gameId: game.id } });
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */

{
  opacity: 0
}

.categorys::-webkit-scrollbar{
  display:none;
}

.sports-table-container {
  width: 100%;
}

@media (min-width: 1000px) {
  .sports-table-container {
    width: 75% !important;
  }
}
</style>
